export default {
  type: "Feature",
  properties: {
    name: "Баянзүрх",
    location: [50.17901, 98.97562],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [107.031943474212, 48.0815479083093],
        [107.028926039205, 48.0851284358287],
        [107.028230732862, 48.0908723958444],
        [107.025518182418, 48.0982890391079],
        [107.025166667108, 48.0992499997877],
        [107.001527777585, 48.1304166671955],
        [106.968694444293, 48.199666667183],
        [106.996083334079, 48.2111111112888],
        [107.031138888549, 48.1867500005122],
        [107.051972223339, 48.1898611107018],
        [107.082138888699, 48.2083333339163],
        [107.089944443781, 48.1993333334666],
        [107.113361109927, 48.1745277777348],
        [107.161361111126, 48.162777778172],
        [107.197944443781, 48.141611112363],
        [107.22305555497, 48.1356388891235],
        [107.252805554533, 48.1092777778472],
        [107.295833332742, 48.0769722224902],
        [107.321944444181, 48.0590833328296],
        [107.344750000312, 48.0357222223027],
        [107.372472222915, 47.9903055560566],
        [107.365249999588, 47.9626944446929],
        [107.411194443769, 47.9432500003873],
        [107.384249999838, 47.9136388894233],
        [107.371916666721, 47.9019722219405],
        [107.363527777185, 47.8791944440684],
        [107.318138888299, 47.8597499997627],
        [107.292444444456, 47.8022500002374],
        [107.257531457711, 47.8100363224184],
        [107.2319999998, 47.8157222222029],
        [107.220250000237, 47.7801111115386],
        [107.227416667046, 47.761305555507],
        [107.216638888574, 47.7252222225276],
        [107.181861111301, 47.74700000015],
        [107.119611111264, 47.7237499999626],
        [107.040111110739, 47.7214722222653],
        [107.032527778135, 47.735444443906],
        [106.963500000625, 47.7436666674828],
        [106.946805556331, 47.7608055558318],
        [106.941388889286, 47.7859444443807],
        [106.945861110802, 47.7995000002249],
        [106.92194444498, 47.812333333017],
        [106.947111110889, 47.8465000002748],
        [106.956222222578, 47.8635555547451],
        [106.951750000162, 47.8765833326547],
        [106.939774510885, 47.8861176599021],
        [106.939250000187, 47.8877500004622],
        [106.939026867596, 47.8886408302102],
        [106.93885692091, 47.8891888590786],
        [106.938644588277, 47.889873567811],
        [106.938405940582, 47.8904709928421],
        [106.938162612814, 47.890943133319],
        [106.937904679158, 47.8913570148144],
        [106.937567109634, 47.8918014921452],
        [106.936626213729, 47.8928955120183],
        [106.934490357144, 47.8954388325362],
        [106.932773022557, 47.8974674863355],
        [106.931312107168, 47.8991989807484],
        [106.929782355871, 47.9010090723109],
        [106.929270138007, 47.901606899339],
        [106.928837251138, 47.9021657794272],
        [106.928556829034, 47.902646878051],
        [106.928403724852, 47.9030422613913],
        [106.928338970068, 47.9033066153081],
        [106.928227043144, 47.9038526926477],
        [106.928165355047, 47.9041536561663],
        [106.928027914357, 47.9049708368347],
        [106.927941878915, 47.9053316619267],
        [106.927816872251, 47.9056471728788],
        [106.927701181664, 47.9058789524518],
        [106.92757244821, 47.9060942339618],
        [106.927277778147, 47.9064166669956],
        [106.92755997821, 47.9064344942565],
        [106.927842372528, 47.906450340311],
        [106.928124962897, 47.9064642033604],
        [106.92840774662, 47.9064760843039],
        [106.928591668771, 47.906482744683],
        [106.928669059929, 47.9064823804575],
        [106.928746245143, 47.9064801474409],
        [106.928886087023, 47.906471298112],
        [106.929031124287, 47.9064721101998],
        [106.929214924129, 47.9064755222276],
        [106.929302744726, 47.9064803003256],
        [106.929520211589, 47.9064963891971],
        [106.929667747169, 47.9065051584863],
        [106.929757510301, 47.9065086496545],
        [106.92995085195, 47.9065086496545],
        [106.930086106389, 47.906506375269],
        [106.930167488739, 47.9065059651782],
        [106.930216650178, 47.9065074310731],
        [106.930276138533, 47.9065124115186],
        [106.930347677803, 47.9065214766849],
        [106.930508293123, 47.9065512757209],
        [106.930592612659, 47.9065631557651],
        [106.930668545117, 47.9065713297032],
        [106.930794500566, 47.9065789622493],
        [106.930919536907, 47.9065799407118],
        [106.931098823052, 47.9065738424089],
        [106.931272480341, 47.9065644211112],
        [106.931379724495, 47.9065613391346],
        [106.931426936204, 47.9065585719206],
        [106.93146822318, 47.9065539143317],
        [106.931590448241, 47.9065363217939],
        [106.931672357593, 47.9065288637161],
        [106.931754321805, 47.9065238140229],
        [106.931831471945, 47.9065214335174],
        [106.931923388953, 47.9065209694672],
        [106.932083037502, 47.906524780794],
        [106.93218335238, 47.9065280318433],
        [106.932242805661, 47.9065318422707],
        [106.932304625958, 47.9065383083962],
        [106.93235934251, 47.9065461306994],
        [106.9324616305, 47.9065671577481],
        [106.932539644889, 47.9065853438386],
        [106.932587874631, 47.9066029004036],
        [106.932628044649, 47.9066228554604],
        [106.932651321801, 47.9066379074135],
        [106.932672729263, 47.906654602428],
        [106.932699219693, 47.9066831487084],
        [106.932733718586, 47.9067348228538],
        [106.932759494955, 47.9067740926503],
        [106.932774903939, 47.9068023790266],
        [106.932796523641, 47.9068637631522],
        [106.932807677932, 47.9069039574517],
        [106.932813677309, 47.9069349732704],
        [106.932815635134, 47.9069700864004],
        [106.932812717733, 47.9070389870596],
        [106.932811152912, 47.9071267608913],
        [106.932816839326, 47.9072794118155],
        [106.932818298925, 47.9074483845354],
        [106.932815908527, 47.907515044084],
        [106.932811186187, 47.9076467488984],
        [106.932808532288, 47.9077052920657],
        [106.932803112074, 47.907731819368],
        [106.932795854545, 47.9077542547551],
        [106.932768686026, 47.9078034611609],
        [106.932727629277, 47.9078691512404],
        [106.932689361325, 47.9079404836664],
        [106.93266025117, 47.9080067834863],
        [106.93263807119, 47.9080723854323],
        [106.932621697234, 47.9081390090081],
        [106.932593588024, 47.9081861361813],
        [106.932557370526, 47.9082295095843],
        [106.932536317397, 47.9082488719879],
        [106.932509825168, 47.9082690581706],
        [106.932416078939, 47.908329386492],
        [106.932317932327, 47.9083898317254],
        [106.932198464588, 47.9084565470321],
        [106.93213537175, 47.9084885458098],
        [106.931993599925, 47.908555564188],
        [106.931937371612, 47.9085844387209],
        [106.93181431288, 47.908654757611],
        [106.93170584295, 47.9087191166939],
        [106.931644276262, 47.9087616177545],
        [106.931610610142, 47.9087905597366],
        [106.931527497496, 47.9088708296251],
        [106.931381976397, 47.9089870256308],
        [106.931262557221, 47.9090826316582],
        [106.931230197815, 47.9091119981203],
        [106.931203968189, 47.9091395164755],
        [106.931163503193, 47.909184181305],
        [106.931154099882, 47.9091985425787],
        [106.931148659883, 47.9092119469738],
        [106.931145774858, 47.90922771119],
        [106.931145527544, 47.9092439655366],
        [106.931138156701, 47.9093193700929],
        [106.931138763743, 47.9094656070522],
        [106.931134389441, 47.9095254092703],
        [106.931128018643, 47.9095665361668],
        [106.931115040527, 47.9096153801457],
        [106.931097707893, 47.9096612941334],
        [106.931081098314, 47.9096934386014],
        [106.93103865481, 47.9097630335372],
        [106.930978117846, 47.9098741025079],
        [106.930930329671, 47.909969601516],
        [106.930887280923, 47.9100670862271],
        [106.930828284498, 47.9102150642739],
        [106.930744717695, 47.9104374639179],
        [106.930639289272, 47.9107219806349],
        [106.930573593796, 47.9109050808049],
        [106.930536437407, 47.9110040422028],
        [106.930521181308, 47.9110554600415],
        [106.930505481843, 47.9111532217439],
        [106.930490266213, 47.9112639759518],
        [106.930488383033, 47.9113229660821],
        [106.930490873255, 47.9114102120117],
        [106.930501384531, 47.9115627810975],
        [106.930500287358, 47.9116245114621],
        [106.930496193645, 47.9116831166825],
        [106.930485113997, 47.9117563053093],
        [106.930455618032, 47.9118917935714],
        [106.930381225213, 47.912231036733],
        [106.930348229987, 47.9124136692555],
        [106.930321932012, 47.9125862761358],
        [106.930299244814, 47.912772803622],
        [106.930297231232, 47.9127950915203],
        [106.930282565988, 47.9129574299415],
        [106.93027428593, 47.9131560865842],
        [106.930268558147, 47.9132306592676],
        [106.930253463926, 47.9133446609274],
        [106.930240752909, 47.9134212130186],
        [106.930229189426, 47.9134718160715],
        [106.930211451198, 47.9135339880032],
        [106.930194286737, 47.9135731507803],
        [106.930175448638, 47.9136020091255],
        [106.930143680986, 47.9136422501897],
        [106.930099349805, 47.913692985443],
        [106.930050682993, 47.9137413105131],
        [106.929998485442, 47.9137839788476],
        [106.929980388384, 47.9138009904234],
        [106.929958115774, 47.9138280330374],
        [106.929934372773, 47.91386351399],
        [106.929916890852, 47.9138952204881],
        [106.929893911375, 47.9139454422284],
        [106.929870993951, 47.9140001255054],
        [106.929849908447, 47.9140588098662],
        [106.929830296031, 47.9141224557868],
        [106.929811300551, 47.9141938259843],
        [106.929798574245, 47.9142534375462],
        [106.929775068665, 47.9143894294287],
        [106.929754656752, 47.9144905204212],
        [106.929743907156, 47.9145914486365],
        [106.929741735293, 47.9146629843094],
        [106.929748620502, 47.9147181172474],
        [106.929758393435, 47.9147646121971],
        [106.929771327485, 47.9148087329367],
        [106.929787859722, 47.914850992979],
        [106.929813602816, 47.914905519774],
        [106.929844649211, 47.9149604908341],
        [106.929914891659, 47.915066542487],
        [106.929942116835, 47.9151113548052],
        [106.929970729666, 47.9151607581625],
        [106.929983667312, 47.9151886551324],
        [106.929993370997, 47.9152255228396],
        [106.930002027871, 47.9152923424677],
        [106.930013431275, 47.9153728326901],
        [106.930016644553, 47.9154253450037],
        [106.930014200195, 47.915466649966],
        [106.930002272487, 47.915558834073],
        [106.929993974442, 47.915668574745],
        [106.929987177366, 47.9158028318353],
        [106.929982047633, 47.9160031926933],
        [106.929983197866, 47.9162156386409],
        [106.929992501353, 47.916465726612],
        [106.929996054574, 47.9166089211648],
        [106.929991175752, 47.916689994148],
        [106.929983287799, 47.9167374810499],
        [106.929966779843, 47.9168139009408],
        [106.92995037441, 47.9168932544202],
        [106.929937549179, 47.9169378886727],
        [106.929918828891, 47.9169828565736],
        [106.929883801197, 47.9170525405424],
        [106.929797681218, 47.9172067347031],
        [106.929748158251, 47.917305064777],
        [106.92970805838, 47.9173967371697],
        [106.929682090456, 47.9174784216918],
        [106.929669088957, 47.9175218445575],
        [106.929664682279, 47.9175465570281],
        [106.929663777561, 47.9175737291443],
        [106.929666494413, 47.9175952751019],
        [106.92967210978, 47.9176116985211],
        [106.929686334357, 47.9176412520422],
        [106.929705993537, 47.9176823591536],
        [106.929729366917, 47.9177258395759],
        [106.929735333919, 47.9177452892138],
        [106.929737972529, 47.9177622567228],
        [106.929736582178, 47.9177828260167],
        [106.929729003591, 47.9178135945218],
        [106.929717986896, 47.9178447029707],
        [106.929692315748, 47.917899521146],
        [106.929659045329, 47.9179746298254],
        [106.929635061309, 47.9180174807222],
        [106.929586206538, 47.9180774079461],
        [106.929572735593, 47.9180965266335],
        [106.929557395857, 47.9181241987728],
        [106.929545739744, 47.9181506037674],
        [106.929535131341, 47.9181896289482],
        [106.929527620204, 47.9182484068386],
        [106.92952426933, 47.9183532731851],
        [106.929522277331, 47.918494678087],
        [106.929522654147, 47.918546202945],
        [106.929525267577, 47.918575063988],
        [106.929532571871, 47.9186137330374],
        [106.929542209006, 47.9186405894916],
        [106.929555023446, 47.9186613494418],
        [106.929584244218, 47.9186983808257],
        [106.929630707691, 47.9187581659567],
        [106.929671667314, 47.9188065971468],
        [106.929718809775, 47.9188558799949],
        [106.929814717975, 47.9189480011494],
        [106.929998836177, 47.9191329278424],
        [106.93005321998, 47.9191839086105],
        [106.930104350935, 47.9192283126366],
        [106.930158555773, 47.9192704350826],
        [106.93028601129, 47.9193621029787],
        [106.930339355477, 47.919404731743],
        [106.930394954264, 47.9194557152091],
        [106.930493550537, 47.9195532610742],
        [106.930580642683, 47.9196368665482],
        [106.930625278734, 47.9196826672214],
        [106.930669879711, 47.9197338674241],
        [106.930739160784, 47.9198196861296],
        [106.930795756919, 47.9198892046231],
        [106.930826681007, 47.9199303369156],
        [106.930876690507, 47.9200074942505],
        [106.930981425552, 47.9201909775317],
        [106.931027887227, 47.920266583536],
        [106.931047293698, 47.9203044297057],
        [106.931060413008, 47.9203365642811],
        [106.931067498766, 47.9203601508004],
        [106.931071601473, 47.9203849541024],
        [106.931073025999, 47.9204112439838],
        [106.931070632004, 47.9204397174191],
        [106.931061342907, 47.9204870019736],
        [106.931048931363, 47.9205432707554],
        [106.9310504746, 47.9205846818376],
        [106.931056144825, 47.9206060479308],
        [106.9310707696, 47.9206428391958],
        [106.93111496948, 47.9207424364143],
        [106.931167942247, 47.9208436829896],
        [106.931285787609, 47.9210450555849],
        [106.931430754726, 47.921302610627],
        [106.93150576358, 47.9214517496985],
        [106.931527639589, 47.9214890598723],
        [106.931550112748, 47.9215215964446],
        [106.931605803265, 47.9215889089011],
        [106.931646865411, 47.9216382475072],
        [106.931666688267, 47.9216658827743],
        [106.931682794226, 47.9216949866344],
        [106.931703294272, 47.9217400147899],
        [106.931728909662, 47.9218033387531],
        [106.93175174165, 47.9218724471557],
        [106.931773250735, 47.9219629405374],
        [106.93179391176, 47.9220959808449],
        [106.93180704366, 47.9222095481322],
        [106.931818326555, 47.9223620650573],
        [106.931825205469, 47.922496636011],
        [106.931828125568, 47.9226251428361],
        [106.931830096882, 47.9226992496707],
        [106.931827527518, 47.9227388998803],
        [106.931818552284, 47.9227830071301],
        [106.931802163939, 47.9228368252593],
        [106.93178833956, 47.922870368173],
        [106.931751777622, 47.9229433274726],
        [106.931739596305, 47.9229743747676],
        [106.931725553392, 47.9230282792317],
        [106.931714958479, 47.9230917857574],
        [106.931708439293, 47.9231763939754],
        [106.931707352013, 47.9232487849035],
        [106.93171012822, 47.9233144758824],
        [106.931716864142, 47.9233755515405],
        [106.931727661403, 47.9234328140732],
        [106.931743292519, 47.9234923770716],
        [106.931760766346, 47.9235427534953],
        [106.931782867186, 47.9235966831405],
        [106.931802689143, 47.9236297970775],
        [106.93184799339, 47.9236777831032],
        [106.931884706414, 47.9237200908096],
        [106.931903806216, 47.9237483421123],
        [106.931912522445, 47.9237683709136],
        [106.931918593768, 47.9237915194631],
        [106.931927733578, 47.9238714368174],
        [106.931938015527, 47.9239715520455],
        [106.931939945472, 47.9240694756259],
        [106.931935943489, 47.9241376559281],
        [106.931926303656, 47.9242224521045],
        [106.931912816523, 47.9243163062526],
        [106.931898405787, 47.9243821690019],
        [106.931869439523, 47.9244677727696],
        [106.931823276423, 47.924571926853],
        [106.931802565036, 47.9246113180579],
        [106.931752024037, 47.9246979866228],
        [106.931732680519, 47.924735948805],
        [106.931700924558, 47.9248104000799],
        [106.931679775202, 47.9248733346367],
        [106.931659243679, 47.9249711781774],
        [106.931645633339, 47.9250531136104],
        [106.931640284172, 47.9251112439888],
        [106.931640372305, 47.9251613254349],
        [106.931644517281, 47.925224920094],
        [106.931650594899, 47.925285367126],
        [106.931658174385, 47.9253319367195],
        [106.931671328769, 47.9253880535159],
        [106.931686085744, 47.9254322156243],
        [106.93170703725, 47.9254777824738],
        [106.931732964705, 47.9255224248201],
        [106.931761440838, 47.9255635643071],
        [106.931788901637, 47.9255962312811],
        [106.931848945772, 47.925650470293],
        [106.931873084475, 47.9256794068792],
        [106.931889660779, 47.9257050330609],
        [106.931901355563, 47.9257330334528],
        [106.931911531392, 47.9257729129896],
        [106.931917787976, 47.9258149491007],
        [106.931919992214, 47.9258702681984],
        [106.931918187275, 47.9259112709884],
        [106.93191177241, 47.9259569340653],
        [106.931875911944, 47.9261147542925],
        [106.93185502429, 47.9262241846984],
        [106.931838711487, 47.9262843754236],
        [106.931803319568, 47.9263727194255],
        [106.931788338661, 47.9264166656966],
        [106.931781819475, 47.9264445797536],
        [106.931780394949, 47.926474930074],
        [106.93178544824, 47.9265420159013],
        [106.931786222556, 47.92660400617],
        [106.931784367255, 47.9266427822387],
        [106.931772653585, 47.9267177272414],
        [106.931763992215, 47.9267535004737],
        [106.931755501715, 47.9267765141249],
        [106.931740539694, 47.9268017661886],
        [106.931709596721, 47.9268422851434],
        [106.931682548711, 47.9268739349841],
        [106.931672631886, 47.9268884059752],
        [106.931662210543, 47.926914772299],
        [106.931655600526, 47.9269504421093],
        [106.931654616667, 47.9269769999886],
        [106.931658383927, 47.9270251424964],
        [106.931661021639, 47.9270855760386],
        [106.931666723341, 47.9271192502533],
        [106.931677197745, 47.9271485411723],
        [106.931698500885, 47.9271934632078],
        [106.931740064852, 47.927270760837],
        [106.931754136544, 47.9273079954677],
        [106.931761934566, 47.927338641665],
        [106.931764508425, 47.9273645745155],
        [106.93176447515, 47.9274068480477],
        [106.93176443558, 47.9274471322794],
        [106.93176206137, 47.927471887018],
        [106.93175467344, 47.927501663571],
        [106.931740441668, 47.9275404989949],
        [106.931709032846, 47.9276060262972],
        [106.931701805894, 47.9276399370335],
        [106.931697803011, 47.9276939620068],
        [106.931697279606, 47.9277490904482],
        [106.931703609934, 47.9278498612821],
        [106.931707128981, 47.9279660698783],
        [106.931715096974, 47.9280284126812],
        [106.931732015021, 47.9280931269963],
        [106.931740881437, 47.9281246842069],
        [106.931748326924, 47.9281416004545],
        [106.931767665945, 47.9281658470762],
        [106.931808615675, 47.9282023352696],
        [106.931863468025, 47.9282469110661],
        [106.931880110878, 47.9282653786444],
        [106.931888839698, 47.9282789826889],
        [106.931892880352, 47.9282927342223],
        [106.931895124161, 47.9283178765688],
        [106.931897422828, 47.928379586249],
        [106.931892186975, 47.9284262556672],
        [106.931877494751, 47.9284936688478],
        [106.931863866424, 47.9285434157461],
        [106.931834373158, 47.9286341411528],
        [106.931791008748, 47.9287681167552],
        [106.931772917986, 47.9288360830189],
        [106.931766126306, 47.9288790337405],
        [106.931765738698, 47.928908203251],
        [106.931769393543, 47.9289667257339],
        [106.931773890153, 47.9290360805507],
        [106.931773266023, 47.9290706576848],
        [106.93176734039, 47.9291131992148],
        [106.931757080925, 47.9291554286801],
        [106.931745574998, 47.9291891379684],
        [106.931730625568, 47.929224121596],
        [106.931694384688, 47.9292897298372],
        [106.931666514698, 47.9293260885282],
        [106.931657659973, 47.9293423464721],
        [106.93165359234, 47.9293648825833],
        [106.931655126583, 47.9294041379906],
        [106.931657479209, 47.9294399049277],
        [106.931662620634, 47.9294755099868],
        [106.931672168736, 47.9295172178454],
        [106.931684975981, 47.9295563815218],
        [106.931708076866, 47.9296077382066],
        [106.931737053023, 47.9296562530337],
        [106.931755952275, 47.9296805212391],
        [106.931803732356, 47.9297321171435],
        [106.931822958962, 47.9297555552747],
        [106.931858664746, 47.9298067824571],
        [106.931879506534, 47.9298456007939],
        [106.931892002614, 47.9298815907629],
        [106.931901862781, 47.9299264732282],
        [106.931906132762, 47.9299693142325],
        [106.931906339606, 47.9300466451366],
        [106.93190747455, 47.9301591440293],
        [106.931903693801, 47.9302351853056],
        [106.931888493459, 47.9303389445867],
        [106.9318591234, 47.9304666788942],
        [106.931826360198, 47.9305845908063],
        [106.931794255301, 47.9306725148248],
        [106.93177161217, 47.9307266477167],
        [106.931753907217, 47.9307576914144],
        [106.931726683839, 47.930791505024],
        [106.931693502453, 47.9308237070485],
        [106.931665302412, 47.9308448725928],
        [106.931599145584, 47.9308870427029],
        [106.931522197791, 47.9309391026575],
        [106.931481350584, 47.9309702722603],
        [106.931442507965, 47.9310058098703],
        [106.931397385381, 47.9310529325468],
        [106.931349997405, 47.9311072506991],
        [106.931314145931, 47.9311550802428],
        [106.931280651581, 47.9312111682609],
        [106.931246371223, 47.931282967435],
        [106.931223202889, 47.9313408496006],
        [106.931202518481, 47.9314039514313],
        [106.931182705518, 47.9314766850011],
        [106.931173406528, 47.9315311884137],
        [106.93117159889, 47.9316124682409],
        [106.93117373478, 47.9317514395773],
        [106.931183211836, 47.9319242640935],
        [106.931200256687, 47.932122221963],
        [106.931227571795, 47.9323362570127],
        [106.931231914621, 47.9324138846931],
        [106.931233984861, 47.9325083944469],
        [106.931233264504, 47.9326189040393],
        [106.931226507897, 47.9326885430419],
        [106.931214422807, 47.9327622173025],
        [106.931195106269, 47.9328395634951],
        [106.931150033148, 47.9329810448394],
        [106.931090385613, 47.9331740690281],
        [106.93104601756, 47.933304535476],
        [106.930984761138, 47.9334649295629],
        [106.930922064901, 47.9336121126089],
        [106.930870136248, 47.9337263651797],
        [106.930832297273, 47.9337988676237],
        [106.930787158501, 47.9338748990074],
        [106.930750019198, 47.9339269985322],
        [106.930707900349, 47.933974764224],
        [106.930652275482, 47.9340293899444],
        [106.93056322821, 47.9341056362662],
        [106.930493393156, 47.9341783077828],
        [106.930456925647, 47.934220084889],
        [106.930433224014, 47.9342508174213],
        [106.930402037324, 47.9343036687794],
        [106.930365685828, 47.9343851995174],
        [106.930332408214, 47.9344720002826],
        [106.930304672223, 47.9345649712964],
        [106.930287737989, 47.9346385421351],
        [106.930276161915, 47.9347084464377],
        [106.930266871919, 47.9347922506619],
        [106.930266983435, 47.934851597823],
        [106.930273251709, 47.9348936240416],
        [106.930290669779, 47.9349681967249],
        [106.930341665835, 47.9351688336748],
        [106.930380576802, 47.9353046762698],
        [106.930404746982, 47.935434266778],
        [106.930425414302, 47.9355996646928],
        [106.930436261924, 47.9356711670907],
        [106.930439071406, 47.9357066822176],
        [106.930437079408, 47.9357532032478],
        [106.930428684236, 47.9358173527886],
        [106.930416039768, 47.9358874279625],
        [106.930399809703, 47.9359510855742],
        [106.930374815745, 47.9360252454688],
        [106.930346890896, 47.9360884723052],
        [106.930316534281, 47.9361442446612],
        [106.930287686727, 47.936186964257],
        [106.930264699157, 47.9362137955303],
        [106.930235411835, 47.9362423759849],
        [106.930123962451, 47.9363359630343],
        [106.929987046965, 47.9364470670785],
        [106.929936314409, 47.9364918650076],
        [106.929877831497, 47.9365501518681],
        [106.929829260012, 47.9366041606535],
        [106.929781538387, 47.936664466492],
        [106.92974177936, 47.9367226274474],
        [106.929708168997, 47.9367818855756],
        [106.929674115268, 47.9368537629908],
        [106.929643485259, 47.9369309634932],
        [106.929617204371, 47.9370139637235],
        [106.929599010186, 47.9370797086617],
        [106.929592196023, 47.9371216314582],
        [106.929591337171, 47.9371630236546],
        [106.929595217745, 47.9372028285477],
        [106.929602765755, 47.9372342616519],
        [106.929622768476, 47.9372933641974],
        [106.929660954589, 47.9374097175844],
        [106.929673484844, 47.9374712869704],
        [106.929686092439, 47.9375652922045],
        [106.92970337561, 47.9377697467764],
        [106.92972346017, 47.9379511067582],
        [106.929727910914, 47.9380390766421],
        [106.929724555544, 47.9381212890663],
        [106.929711843627, 47.9382570911919],
        [106.929700453713, 47.938377865646],
        [106.929690218529, 47.9384556992712],
        [106.929677670288, 47.938522638509],
        [106.929649138397, 47.9386513845538],
        [106.92962853403, 47.9387668745916],
        [106.929612043161, 47.9388242531368],
        [106.929588182349, 47.9388801576932],
        [106.929562622717, 47.9389258315619],
        [106.929543379024, 47.9389528597867],
        [106.929519517312, 47.9389814789122],
        [106.929451212004, 47.9390512006525],
        [106.929406055245, 47.9390896574617],
        [106.929298163579, 47.9391693895557],
        [106.929258597906, 47.9392039325155],
        [106.929207890532, 47.9392567254176],
        [106.929170385205, 47.9393029127992],
        [106.929146376004, 47.9393397256479],
        [106.929115767579, 47.9393948289083],
        [106.929077607546, 47.9394701588208],
        [106.929048583725, 47.9395389542594],
        [106.929033535369, 47.9395838762949],
        [106.929020254181, 47.9396336609647],
        [106.928994206218, 47.9397673604753],
        [106.928984955791, 47.9398371442688],
        [106.928973678293, 47.9399879740658],
        [106.92896617435, 47.9400538242247],
        [106.928946356889, 47.9401711542754],
        [106.92891421422, 47.9403471902706],
        [106.92888966003, 47.9404596747742],
        [106.928864214612, 47.940563112098],
        [106.928837226857, 47.9406601462488],
        [106.928808359518, 47.9407519571371],
        [106.928761627147, 47.9408773990727],
        [106.928657790525, 47.9411249770361],
        [106.928560449705, 47.9413586101118],
        [106.928516041182, 47.9414750992964],
        [106.928477836183, 47.9415910057204],
        [106.928429637018, 47.9417527919578],
        [106.928392785499, 47.9419009120975],
        [106.928369940021, 47.9419682893052],
        [106.928336800003, 47.9420437055526],
        [106.928322287644, 47.9420699001059],
        [106.928306857975, 47.9420928463078],
        [106.928285054812, 47.9421200957659],
        [106.92826124616, 47.9421459404828],
        [106.928235790849, 47.9421699946496],
        [106.928208972166, 47.9421919857716],
        [106.928177511183, 47.9422144229573],
        [106.92814456452, 47.9422349517816],
        [106.928110716736, 47.9422532089185],
        [106.928076404003, 47.9422689614435],
        [106.928045290158, 47.9422808405883],
        [106.928010180625, 47.9422920371479],
        [106.927923291727, 47.9423137809563],
        [106.927843181917, 47.9423283391816],
        [106.927750118273, 47.9423394377149],
        [106.927684396718, 47.9423424549404],
        [106.927540351406, 47.9423409656631],
        [106.927484256194, 47.9423439019496],
        [106.927426966681, 47.9423493608344],
        [106.927392775356, 47.9423551875419],
        [106.927354326641, 47.9423659677153],
        [106.927321112879, 47.9423791400853],
        [106.927301585, 47.9423896891329],
        [106.927282167738, 47.9424028686975],
        [106.927241110989, 47.9424389809743],
        [106.927208083386, 47.9424783128239],
        [106.927181410394, 47.9425244822191],
        [106.927173395636, 47.9425450946804],
        [106.927167459211, 47.9425686865957],
        [106.927156997398, 47.9426483881127],
        [106.927151100543, 47.9427013500873],
        [106.92714853118, 47.9427605875311],
        [106.927152040334, 47.9429501358401],
        [106.927151307387, 47.9430157242963],
        [106.927144742336, 47.943173956413],
        [106.927136920033, 47.9432792067701],
        [106.92713133974, 47.9433601718345],
        [106.92712217295, 47.9434029516849],
        [106.927102154941, 47.9434511562459],
        [106.927077095332, 47.9434914557661],
        [106.927051285688, 47.9435200766902],
        [106.927002407535, 47.9435642082217],
        [106.926950637162, 47.9436077956633],
        [106.926853638984, 47.9436826174589],
        [106.926566614957, 47.9438986786811],
        [106.926401064158, 47.9440331210317],
        [106.926241105343, 47.9441707442844],
        [106.926167849267, 47.9442374461013],
        [106.926088335708, 47.9443003617723],
        [106.926022901036, 47.944345775737],
        [106.925939636405, 47.9443981477564],
        [106.925749200465, 47.944503693091],
        [106.92559511872, 47.9445980391682],
        [106.925548918748, 47.9446270485994],
        [106.925461640442, 47.9446814521873],
        [106.925333150704, 47.9447577218914],
        [106.925143216586, 47.9448727568723],
        [106.925053377012, 47.9449251540727],
        [106.924951556669, 47.9449831189758],
        [106.924889268725, 47.9450148137827],
        [106.924784533679, 47.9450589219318],
        [106.924699387667, 47.9451000542242],
        [106.92465909714, 47.9451235490126],
        [106.924630088608, 47.9451435679214],
        [106.924593346806, 47.945176289754],
        [106.924561771609, 47.9452135342772],
        [106.924544410196, 47.9452405669986],
        [106.924528496693, 47.9452723256573],
        [106.924516868459, 47.945300691174],
        [106.924510677526, 47.945322917019],
        [106.924508967915, 47.9453496277832],
        [106.924513525679, 47.9453996318875],
        [106.924520431573, 47.9454712008353],
        [106.924541464917, 47.9456215099248],
        [106.924550906, 47.9457192896136],
        [106.92455867884, 47.9457668052939],
        [106.924580933463, 47.9458468458553],
        [106.924611821578, 47.9459247325405],
        [106.924631975385, 47.9459665420223],
        [106.924650008591, 47.9459982089502],
        [106.924668518437, 47.9460268019953],
        [106.924683275413, 47.9460452965532],
        [106.924706053442, 47.946065818183],
        [106.924756309356, 47.9461023054771],
        [106.924925045554, 47.9462292079116],
        [106.92499026349, 47.9462745939974],
        [106.925051793306, 47.9463144024878],
        [106.925186002732, 47.9463939978847],
        [106.925244802206, 47.9464254831496],
        [106.925301218477, 47.9464531579869],
        [106.925445322244, 47.9465142687186],
        [106.925601436457, 47.946580472311],
        [106.925819662348, 47.9466705807827],
        [106.925878784678, 47.9466974408343],
        [106.925929807714, 47.9467231947197],
        [106.926021175237, 47.9467757627913],
        [106.92612332653, 47.9468417100769],
        [106.926208418584, 47.9469006741269],
        [106.926269103936, 47.9469477896089],
        [106.926307100292, 47.9469813136367],
        [106.926344736021, 47.9470178162193],
        [106.926420590238, 47.9471014198947],
        [106.926469131146, 47.9471633804857],
        [106.926520202745, 47.9472373910928],
        [106.926553722277, 47.947290678622],
        [106.926583197557, 47.9473422142718],
        [106.926625178809, 47.9474195910413],
        [106.926635983264, 47.9474450661369],
        [106.926643043841, 47.9474682650484],
        [106.926648959582, 47.9475152501287],
        [106.92664737048, 47.9475846589049],
        [106.926641561759, 47.9476469747282],
        [106.926628761708, 47.947719968202],
        [106.926614685519, 47.9477798450638],
        [106.92659765146, 47.9478369556111],
        [106.926586465693, 47.9478758584841],
        [106.92657618914, 47.9478955500397],
        [106.926554568539, 47.9479186311399],
        [106.926526576241, 47.947938734585],
        [106.926505102229, 47.9479495228522],
        [106.926476175535, 47.9479607562839],
        [106.926436036994, 47.9479720346817],
        [106.926374587217, 47.9479836368354],
        [106.926325394302, 47.947990203685],
        [106.926269409706, 47.9479936507864],
        [106.926044034205, 47.9479944754647],
        [106.925834359968, 47.9480024389614],
        [106.925713677244, 47.9480106048056],
        [106.925638796993, 47.9480171131993],
        [106.925595946995, 47.9480231674353],
        [106.925559123355, 47.9480313449707],
        [106.925506170374, 47.9480458501359],
        [106.925431663341, 47.9480686056817],
        [106.925367726939, 47.9480974721207],
        [106.925304010871, 47.9481322884744],
        [106.925274523001, 47.9481525070326],
        [106.92524073727, 47.9481790100533],
        [106.925189275365, 47.9482255337814],
        [106.925165779677, 47.9482525871872],
        [106.925141283943, 47.9482858962771],
        [106.925121988989, 47.9483166315074],
        [106.925099640836, 47.9483580614754],
        [106.925075434684, 47.9484104227029],
        [106.92504536765, 47.9484880117124],
        [106.925023015, 47.9485480378617],
        [106.925010662812, 47.9485878562446],
        [106.924998033632, 47.9486456394847],
        [106.924994265473, 47.9487032734374],
        [106.924998097484, 47.9488064418638],
        [106.925005886512, 47.9489090778917],
        [106.925016543479, 47.9489848035059],
        [106.925027318256, 47.9490362384317],
        [106.92504673372, 47.9490815741554],
        [106.925062726364, 47.9491074791269],
        [106.925087336312, 47.9491404509711],
        [106.925121029412, 47.9491817721212],
        [106.925148980341, 47.9492089001707],
        [106.925177438488, 47.949229903837],
        [106.925215645286, 47.949253441793],
        [106.925263589943, 47.9492780238618],
        [106.925335911623, 47.949308996513],
        [106.925400150197, 47.9493345660375],
        [106.925452781221, 47.9493526981685],
        [106.925496153725, 47.9493657581233],
        [106.925527423152, 47.9493732836502],
        [106.925589808223, 47.949382163556],
        [106.925622627183, 47.9493834891567],
        [106.925681431153, 47.9493826114185],
        [106.925751063861, 47.9493806562923],
        [106.925961691379, 47.9493699696484],
        [106.926113024796, 47.9494454740295],
        [106.926187306999, 47.949515838785],
        [106.926306310688, 47.9495419101311],
        [106.926399079354, 47.9494968028352],
        [106.92659181486, 47.9495277359163],
        [106.926777413347, 47.9496181555535],
        [106.926820243559, 47.9497109547968],
        [106.926774930319, 47.949775716776],
        [106.926743537684, 47.9498134559263],
        [106.92668749733, 47.9498957906583],
        [106.926645707633, 47.9499639898463],
        [106.926624072643, 47.9500179536657],
        [106.926608567432, 47.9500777720716],
        [106.926604725528, 47.9501334230191],
        [106.926609965877, 47.9501948772918],
        [106.926624582558, 47.9502700705074],
        [106.926640546424, 47.9503213642396],
        [106.926664152729, 47.9503805800998],
        [106.926686467606, 47.9504300742885],
        [106.926705717595, 47.9504652476731],
        [106.92672790297, 47.9504988445461],
        [106.926749350902, 47.9505260571319],
        [106.926777445723, 47.9505565135723],
        [106.92680147291, 47.9505767986803],
        [106.926843778817, 47.9506018960607],
        [106.926872235166, 47.9506144460998],
        [106.926906755642, 47.9506266481014],
        [106.926938787695, 47.9506356718988],
        [106.926981325628, 47.9506452478799],
        [106.927067560719, 47.9506596828981],
        [106.927150842437, 47.9506741664796],
        [106.927193348894, 47.9506856328358],
        [106.927267422454, 47.9507099289202],
        [106.927414051517, 47.9507590840645],
        [106.927483068189, 47.9507866788622],
        [106.927515939309, 47.950797077723],
        [106.927572494975, 47.9508080395594],
        [106.927625876033, 47.9508131000446],
        [106.927673127313, 47.9508123068425],
        [106.927694619311, 47.9508091897923],
        [106.927740609741, 47.9507992621762],
        [106.927819905664, 47.9507860187598],
        [106.927880517272, 47.9507785561855],
        [106.927934714915, 47.9507741647959],
        [106.927989528594, 47.950772009121],
        [106.92803512692, 47.9507724785671],
        [106.928082436655, 47.9507759310644],
        [106.928135980491, 47.9507826957649],
        [106.928196164921, 47.950793919304],
        [106.928278992482, 47.9508140434334],
        [106.92839141763, 47.950846108761],
        [106.928512228956, 47.9508875495209],
        [106.928599680831, 47.9509216653026],
        [106.928683298895, 47.9509581301137],
        [106.928743860141, 47.9509873005235],
        [106.928809773253, 47.9510215188281],
        [106.928879177532, 47.9510600565764],
        [106.928924509658, 47.9510870892978],
        [106.928964010581, 47.9511162039497],
        [106.928990179953, 47.9511393462039],
        [106.929025292184, 47.9511747309291],
        [106.929068144879, 47.9512208679487],
        [106.929102448619, 47.9512627700609],
        [106.929158858595, 47.9513491715271],
        [106.929227894152, 47.9514572007893],
        [106.929271148845, 47.9515226426559],
        [106.92929966185, 47.9515592261774],
        [106.929324515514, 47.9515850286262],
        [106.929376302974, 47.9516333770787],
        [106.929437585476, 47.9516919040582],
        [106.929504480647, 47.9517423964945],
        [106.929548515951, 47.9517719275325],
        [106.92958924265, 47.9517965581647],
        [106.929623018488, 47.9518142667151],
        [106.929706638351, 47.9518541426546],
        [106.929809120594, 47.9519080066492],
        [106.929878599518, 47.9519485292013],
        [106.929912732387, 47.9519738145399],
        [106.929948669296, 47.9520049229889],
        [106.929981937916, 47.9520354945425],
        [106.929997846024, 47.9520557122014],
        [106.930005633253, 47.9520719071928],
        [106.930010914972, 47.9520892407259],
        [106.930012391659, 47.9521289206132],
        [106.930011475249, 47.9521587061594],
        [106.930008333918, 47.9521786198475],
        [106.929999617688, 47.9522020327976],
        [106.929980942367, 47.9522366530991],
        [106.929965506403, 47.952260752232],
        [106.929910729597, 47.9523351090781],
        [106.929883044867, 47.9523852049133],
        [106.929863995427, 47.9524292006471],
        [106.929850929177, 47.9524750795613],
        [106.929841185023, 47.9525308312329],
        [106.92983594827, 47.9525579601818],
        [106.929830922859, 47.9525726928755],
        [106.929811357208, 47.9526028012783],
        [106.929793694523, 47.9526203317629],
        [106.929754064998, 47.9526514087356],
        [106.929676079388, 47.9527147650744],
        [106.929607652671, 47.9527670282758],
        [106.929536894013, 47.9528175692754],
        [106.92946936392, 47.9528626576856],
        [106.929387971678, 47.9529148327534],
        [106.929333508734, 47.9529443512009],
        [106.929269675755, 47.9529721141718],
        [106.929211164963, 47.9529920665307],
        [106.929149654933, 47.9530079125852],
        [106.929099747955, 47.9530157771564],
        [106.929055718946, 47.9530184499416],
        [106.929020006868, 47.9530171171463],
        [106.928990286972, 47.9530122680018],
        [106.928951486622, 47.9530023862512],
        [106.928910319256, 47.9529889548764],
        [106.928864582435, 47.9529700969924],
        [106.928827986323, 47.952953055739],
        [106.928804333253, 47.9529393455744],
        [106.92878633692, 47.9529242495545],
        [106.928746002326, 47.9528807691323],
        [106.928714321009, 47.9528553497946],
        [106.928676079138, 47.9528283404556],
        [106.928626076832, 47.9527971474704],
        [106.92859395125, 47.9527805981461],
        [106.928567334015, 47.952769478029],
        [106.928537725636, 47.9527601196838],
        [106.928509028269, 47.9527536004983],
        [106.928482572912, 47.9527499834251],
        [106.928451099339, 47.9527478322467],
        [106.928388407599, 47.9527488844535],
        [106.928342881219, 47.9527521525898],
        [106.928308410205, 47.9527569711573],
        [106.928273599247, 47.9527656136422],
        [106.928219073352, 47.9527837565652],
        [106.928132431766, 47.9528155529954],
        [106.928075694438, 47.9528417907161],
        [106.928052032375, 47.952856146594],
        [106.928034066619, 47.9528694610568],
        [106.928015729442, 47.9528853889496],
        [106.928004216322, 47.9529026775166],
        [106.928000996749, 47.9529172627215],
        [106.928002179357, 47.9529431829816],
        [106.928003788244, 47.952959771876],
        [106.928011565581, 47.9530049232387],
        [106.928014132246, 47.953073919226],
        [106.928014921851, 47.9531134687116],
        [106.92801289388, 47.9531358366496],
        [106.927997043329, 47.9531860970608],
        [106.927990849698, 47.9532244936156],
        [106.927989340636, 47.9532647886392],
        [106.927993602523, 47.9533048570336],
        [106.928007314486, 47.9533668562954],
        [106.928023777475, 47.9534344862126],
        [106.928039896924, 47.9534805800648],
        [106.928063874648, 47.9535270408403],
        [106.928107986395, 47.9535960898877],
        [106.928152677304, 47.9536638286228],
        [106.928186524189, 47.9537066615333],
        [106.928225784992, 47.9537495924698],
        [106.928241057279, 47.953763248675],
        [106.928256385324, 47.9537745279721],
        [106.928284739149, 47.9537906815947],
        [106.928325007193, 47.9538090844218],
        [106.928400445924, 47.9538363869398],
        [106.928504485793, 47.9538703489375],
        [106.928554424247, 47.9538885835913],
        [106.92858718565, 47.9539022901586],
        [106.928622784414, 47.953919551746],
        [106.928648634527, 47.9539345857126],
        [106.928680829357, 47.953957446479],
        [106.928699813146, 47.9539765786562],
        [106.928709424201, 47.9539942674215],
        [106.928719382394, 47.9540262437162],
        [106.928730502511, 47.9540662689432],
        [106.928736384976, 47.9541021402017],
        [106.928737925515, 47.9541376787109],
        [106.92873541101, 47.954171194645],
        [106.928727503272, 47.95420473576],
        [106.928706900703, 47.9542621394862],
        [106.928686070606, 47.9543198624717],
        [106.928668119238, 47.9543627790191],
        [106.928646172183, 47.9544096229058],
        [106.928628452841, 47.9544396269873],
        [106.928606267465, 47.954468542889],
        [106.928577539522, 47.9544999984762],
        [106.928536384746, 47.9545372645832],
        [106.928470932987, 47.9545874935181],
        [106.928398413456, 47.9546387063113],
        [106.92835411555, 47.9546726512219],
        [106.928326161923, 47.954697055225],
        [106.928289908453, 47.9547357728377],
        [106.928261700317, 47.9547743186799],
        [106.928245058363, 47.9548049855617],
        [106.928228850781, 47.9548439100185],
        [106.928214813263, 47.9548891288303],
        [106.928204146404, 47.9549419316249],
        [106.928197690171, 47.9549941606521],
        [106.928197063344, 47.9550372777482],
        [106.928199417769, 47.9550596357936],
        [106.928204239034, 47.9550844750685],
        [106.928226638449, 47.955165336711],
        [106.928242190425, 47.9552281615505],
        [106.928255061522, 47.9552624670892],
        [106.928275349328, 47.9552987484386],
        [106.92830021918, 47.955333128621],
        [106.928319430497, 47.9553543364335],
        [106.928355472627, 47.9553893362489],
        [106.928425247427, 47.955454823981],
        [106.928480207695, 47.955498462684],
        [106.928538233753, 47.9555386300038],
        [106.928580271662, 47.9555633910377],
        [106.928690180507, 47.9556217822195],
        [106.928772636648, 47.9556676260602],
        [106.928795050451, 47.9556820197095],
        [106.928813438889, 47.955695891752],
        [106.928841178478, 47.9557217544554],
        [106.928872411932, 47.955756799237],
        [106.928914164757, 47.9558100058272],
        [106.928927070028, 47.9558311578817],
        [106.92893616757, 47.9558509537585],
        [106.928943685902, 47.9558764972026],
        [106.928948919957, 47.9559078754481],
        [106.928952406628, 47.9559385171489],
        [106.928950779755, 47.9559578390831],
        [106.928944864914, 47.9559745925535],
        [106.928934398604, 47.9559938236561],
        [106.928920931256, 47.9560118325801],
        [106.928897032672, 47.9560373040784],
        [106.928828409004, 47.9560979732429],
        [106.92879956235, 47.9561273298125],
        [106.928767047361, 47.9561632820099],
        [106.928726798203, 47.9562100314678],
        [106.928702673889, 47.956242925071],
        [106.928685970781, 47.9562718454694],
        [106.928666281024, 47.9563125757648],
        [106.92864094982, 47.956370406669],
        [106.928627497761, 47.956413216197],
        [106.928622368927, 47.9564440089839],
        [106.928620458767, 47.9564780069545],
        [106.928621618893, 47.9565159304659],
        [106.928626082228, 47.9565656018211],
        [106.928633950397, 47.9566150042791],
        [106.928652117601, 47.9566937201391],
        [106.928661939997, 47.9567490967934],
        [106.928666653343, 47.9567639104262],
        [106.928672927913, 47.9567766942891],
        [106.928687150692, 47.9567966421513],
        [106.928707579691, 47.9568189642239],
        [106.928728225427, 47.9568370450936],
        [106.928769653597, 47.9568679152222],
        [106.928842904277, 47.9569192970879],
        [106.928871662797, 47.9569423826849],
        [106.928905627493, 47.956974932747],
        [106.928927007975, 47.9570009699189],
        [106.928944322622, 47.9570325864847],
        [106.928957999512, 47.957071869771],
        [106.928964110405, 47.9571002487775],
        [106.928967298502, 47.9571312295227],
        [106.928966458535, 47.9571637400147],
        [106.928959773875, 47.957214679414],
        [106.928945075355, 47.957295869309],
        [106.928925535785, 47.95736138492],
        [106.928920106578, 47.9573867529963],
        [106.928917975184, 47.9574215288805],
        [106.928920197409, 47.9574843591159],
        [106.928918167639, 47.9575397060926],
        [106.928919726165, 47.9575546006644],
        [106.928923297372, 47.9575676309415],
        [106.92893184363, 47.9575845840613],
        [106.928953493909, 47.9576171170364],
        [106.928972384168, 47.957645379131],
        [106.928979881816, 47.9576595254668],
        [106.928986121313, 47.9576832504817],
        [106.928989447905, 47.9577260240368],
        [106.928994147762, 47.9577804617989],
        [106.928992813168, 47.9578164328821],
        [106.928989314805, 47.9578350758281],
        [106.928983328918, 47.9578557107725],
        [106.9289577504, 47.9579217704734],
        [106.928937178408, 47.9579734518134],
        [106.928915424707, 47.9580224702609],
        [106.928888178846, 47.9580861161814],
        [106.928877710738, 47.9581037267057],
        [106.928865837888, 47.9581185295465],
        [106.928838312338, 47.958143295077],
        [106.928800398719, 47.9581696227299],
        [106.928774431695, 47.958184621623],
        [106.92874496271, 47.9581990521446],
        [106.92867492261, 47.9582264868629],
        [106.928606645181, 47.958244110877],
        [106.928583715166, 47.9582518252616],
        [106.928549296313, 47.9582682612713],
        [106.928521198794, 47.9582862036455],
        [106.928507848359, 47.9582974505669],
        [106.928495105864, 47.9583106346281],
        [106.928470193744, 47.9583441964276],
        [106.928458705805, 47.9583642971746],
        [106.928449383432, 47.9583856677644],
        [106.928442413687, 47.9584078927101],
        [106.928437961143, 47.9584304423111],
        [106.928436844185, 47.9584471912849],
        [106.928437949452, 47.9584660060014],
        [106.928448677465, 47.9585278694657],
        [106.928455379212, 47.9585708291805],
        [106.928461872318, 47.958596686488],
        [106.928473327882, 47.9586241364947],
        [106.928500216712, 47.9586746055486],
        [106.928538382141, 47.9587477644978],
        [106.928560265344, 47.9587912431214],
        [106.928569287343, 47.9588162847438],
        [106.928572308166, 47.9588343629156],
        [106.928574867636, 47.9588709464371],
        [106.928579900242, 47.9589074157447],
        [106.92858044703, 47.9589256081304],
        [106.928577485563, 47.9589487198076],
        [106.928571503272, 47.9589709906188],
        [106.928561638609, 47.9589933675499],
        [106.928545027231, 47.9590214299951],
        [106.928519392956, 47.9590560305115],
        [106.92848056023, 47.95909869345],
        [106.928456931442, 47.959121558713],
        [106.928428312317, 47.9591460409571],
        [106.92832231822, 47.959227526729],
        [106.928105187704, 47.9593930577435],
        [106.927946853964, 47.9595195114164],
        [106.927859512706, 47.9595900875126],
        [106.927812784832, 47.9596312737643],
        [106.927768227921, 47.9596757982995],
        [106.927720688859, 47.9597280471117],
        [106.927664148482, 47.9597985000008],
        [106.927582278699, 47.9599136815712],
        [106.927508037866, 47.9600207818337],
        [106.927451305034, 47.9601087139461],
        [106.92740547828, 47.9601782324395],
        [106.927394931931, 47.9601984114276],
        [106.927387986466, 47.9602169068848],
        [106.927383374743, 47.9602371515234],
        [106.927379219875, 47.9602670476862],
        [106.927375763781, 47.9603057275274],
        [106.927375056014, 47.9603456799093],
        [106.92737689243, 47.9603885182156],
        [106.927381431308, 47.9604217535611],
        [106.927393289769, 47.9604632707634],
        [106.927417029173, 47.960521144835],
        [106.927447757208, 47.9605849067681],
        [106.927462250682, 47.9606225676774],
        [106.927471047851, 47.9606392707857],
        [106.927486416365, 47.9606592150508],
        [106.927508062147, 47.9606815020497],
        [106.927544635776, 47.9607118370816],
        [106.927581651872, 47.960754066547],
        [106.92762229853, 47.9607986171625],
        [106.927651963567, 47.9608338292179],
        [106.927682295901, 47.9608624402495],
        [106.92771049954, 47.9608828395715],
        [106.927742739336, 47.960898333991],
        [106.927814818199, 47.9609239394883],
        [106.927921607296, 47.9609663479187],
        [106.927985084144, 47.9609957548503],
        [106.928018566803, 47.9610150354156],
        [106.928051530554, 47.9610372459722],
        [106.928084032952, 47.9610624260902],
        [106.928116218789, 47.9610906836881],
        [106.92813826297, 47.9611124688654],
        [106.928159464488, 47.9611360212105],
        [106.928199248696, 47.9611883248813],
        [106.928215889752, 47.9612146327491],
        [106.92823145162, 47.9612431889221],
        [106.928246147442, 47.9612743657195],
        [106.928260459253, 47.9613091874691],
        [106.928275056149, 47.9613493619835],
        [106.928282918022, 47.9613792779314],
        [106.928287202393, 47.9614187105051],
        [106.928286319258, 47.9614706382594],
        [106.928283232785, 47.9615124738216],
        [106.928277676773, 47.9615431559919],
        [106.928266988331, 47.9615785335226],
        [106.928254438292, 47.9616044906548],
        [106.928232522713, 47.9616323354639],
        [106.928194432827, 47.961668347916],
        [106.928172652146, 47.9616857102274],
        [106.928119772909, 47.9617217820346],
        [106.928097799774, 47.9617385337064],
        [106.928061319674, 47.9617712474451],
        [106.928027776761, 47.9618055556819],
        [106.931916665622, 47.9624999995753],
        [106.954222222977, 47.9730277782094],
        [107.002490290495, 47.9832388614843],
        [107.002805555932, 47.9833055561066],
        [107.035499999725, 48.0418055558818],
        [107.033192668507, 48.0564826913232],
        [107.033165633987, 48.0616269132515],
        [107.032744994986, 48.0660891388028],
        [107.032693855937, 48.0691170077438],
        [107.032167742647, 48.0730670801817],
        [107.031901404826, 48.0771396600673],
        [107.031943474212, 48.0815479083093],
      ],
    ],
  },
};
